export const DIFFICULTIES = ['Easy', 'Medium', 'Hard'];
const DIFFICULTY_RANK = { Easy: 0, Medium: 1, Hard: 2 };
const STATUS_VALUES = ['solved', 'attempted', 'todo'];
const SORT_KEYS = ['number', 'acceptance', 'difficulty'];

export function readFilters(params) {
  const difficulty = params.get('difficulty');
  const status = params.get('status');
  const sort = params.get('sort');
  return {
    query: params.get('q') ?? '',
    difficulty: DIFFICULTIES.includes(difficulty) ? difficulty : 'all',
    status: STATUS_VALUES.includes(status) ? status : 'all',
    topic: params.get('topic') ?? '',
    sort: SORT_KEYS.includes(sort) ? sort : 'number',
    direction: params.get('dir') === 'desc' ? 'desc' : 'asc',
  };
}

export function writeFilters(filters) {
  const params = new URLSearchParams();
  if (filters.query) params.set('q', filters.query);
  if (filters.difficulty !== 'all') params.set('difficulty', filters.difficulty);
  if (filters.status !== 'all') params.set('status', filters.status);
  if (filters.topic) params.set('topic', filters.topic);
  if (filters.sort !== 'number') params.set('sort', filters.sort);
  if (filters.direction === 'desc') params.set('dir', 'desc');
  return params;
}

export const hasActiveFilters = (filters) =>
  Boolean(filters.query) || filters.difficulty !== 'all' || filters.status !== 'all' || Boolean(filters.topic);

const statusOf = (problem) => (problem.status === 'unattempted' ? 'todo' : problem.status);

export function acceptanceOf(problem) {
  return problem.submissionCount > 0 ? problem.acceptedCount / problem.submissionCount : -1;
}

export function applyFilters(problems, filters) {
  const query = filters.query.trim().toLowerCase();
  const filtered = problems.filter((problem) => {
    if (filters.difficulty !== 'all' && problem.difficulty !== filters.difficulty) return false;
    if (filters.status !== 'all' && statusOf(problem) !== filters.status) return false;
    if (filters.topic && !problem.tags.includes(filters.topic)) return false;
    if (query && !problem.title.toLowerCase().includes(query) && String(problem.id) !== query) return false;
    return true;
  });
  const direction = filters.direction === 'desc' ? -1 : 1;
  const compare = {
    number: (a, b) => a.id - b.id,
    acceptance: (a, b) => acceptanceOf(a) - acceptanceOf(b) || a.id - b.id,
    difficulty: (a, b) => (DIFFICULTY_RANK[a.difficulty] ?? 3) - (DIFFICULTY_RANK[b.difficulty] ?? 3) || a.id - b.id,
  }[filters.sort];
  return [...filtered].sort((a, b) => compare(a, b) * direction);
}
